export default "__VITE_ASSET__DphWe0BR__"